export const VERSION = '1.4.52';

export const CHANGELOG = [
  {
    version: '1.4.52',
    date: '2026-08-16',
    changes: [
      'CoinGecko Demo API key is live (VUE_APP_COINGECKO_KEY configured) — verified directly: a request that used to be rejected outright now returns real prices for all 47 BSC default token addresses in one batched call. Discovered-token pricing on any wallet should now take seconds instead of minutes',
    ],
  },
  {
    version: '1.4.51',
    date: '2026-08-16',
    changes: [
      'Speed: added optional VUE_APP_COINGECKO_KEY support (free CoinGecko Demo API signup, no payment) — with a key, discovered-token pricing batches up to 100 addresses per request at 100 calls/min, instead of one request per address paced 1.5s apart. A wallet holding ~96 unpriced tokens went from ~96+ seconds down to effectively one request. Without a key, behavior is unchanged (still works, just slower on long discovered-token lists)',
    ],
  },
  {
    version: '1.4.50',
    date: '2026-08-11',
    changes: [
      'BSC wallet: "⚡ Fast Update" button — refreshes USDT prices from Binance only (no balanceOf re-fetch, no token rediscovery/CoinGecko pass), near-instant even with a long token list. Only reprices tokens whose contract address is trusted (native BNB + the default list), same rule as regular loading',
      'BSC wallet: sending a coin now only re-fetches that one coin\'s balance + price afterward, not a full reload of every token — a small spinner shows next to the affected row while it updates',
      'BSC wallet: native BNB row is now color-coded (gold accent + left border) to stand out from BEP20 tokens in the balance table',
      'BSC wallet: discovered/priced tokens now stream into the table as each one resolves during the paced CoinGecko fallback, instead of appearing all at once when the whole batch finishes — sorting itself only happens once, after everything is priced, so rows don\'t jump around mid-load',
    ],
  },
  {
    version: '1.4.49',
    date: '2026-08-11',
    changes: [
      'Fix: fetchPrices() cache was keyed purely by time, not by which tickers it actually held — two pages calling it with different ticker sets within 60s of each other meant the second page could get back a cache missing its own tickers entirely (e.g. BSC\'s native BNB balance silently showing no USDT value because an ETH page\'s fetch, for different tickers, populated the cache moments earlier). Now only short-circuits when every requested ticker is actually present, and merges new fetches into the existing cache instead of overwriting it',
      'Feature: live pricing progress message ("Pricing via Binance…", "Pricing 4/12 tokens via CoinGecko…") in place of the static "Scanning all tokens…" text, across all five multi-token wallets — makes the paced CoinGecko fallback for discovered tokens visibly show what\'s happening instead of just sitting there',
    ],
  },
  {
    version: '1.4.48',
    date: '2026-08-11',
    changes: [
      'Security fix: discovered ERC20/TRC20 tokens could be mispriced as if they were a real, valuable asset — ticker-based Binance pricing keyed off a token\'s on-chain symbol(), which the token\'s deployer fully controls. A worthless airdrop-spam token naming itself "BAKE" (or even "USDT") got silently priced using the REAL BAKEUSDT/1.00 value. Confirmed live on a real wallet: enabling BSC discovery surfaced dozens of phishing-style spam tokens (fake-URL names, a unicode-lookalike "ΒΝΒ", a typosquat "U5DT")',
      'Ticker-based pricing (Binance + the stablecoin $1.00 shortcut) is now restricted to the hardcoded default token list and tokens the user explicitly added — discovered tokens always price strictly by contract/mint address via CoinGecko instead, which can\'t be spoofed by symbol alone. Solana was already safe (ticker comes from Jupiter\'s vetted "strict" list, not raw on-chain metadata)',
    ],
  },
  {
    version: '1.4.47',
    date: '2026-08-11',
    changes: [
      'BSC token discovery is live — VUE_APP_MEGANODE_KEY configured (free nodereal.io signup). Verified end-to-end against nr_getTokenHoldings directly: correctly returns native BNB balance plus every BEP20 token an address has ever held, decoded and cross-checked against the app\'s own parsing logic before deploying',
      'BSC wallet now discovers tokens beyond the default list, same as ETH/Polygon always have — new tokens still pass through the existing $0.01 minimum-value filter before showing, so the wave of zero-value BSC airdrop-spam tokens (fake-URL-named "claim" tokens, a common phishing pattern) stays hidden',
    ],
  },
  {
    version: '1.4.46',
    date: '2026-08-11',
    changes: [
      'Feature: "Total Value" banner above each wallet\'s balance table (Ethereum, BSC, Polygon, Tron, Solana, Bitcoin), summing every row\'s USDT value',
      'Each banner has its own ↻ refresh button — reloads that wallet\'s balances + prices immediately, independent of the navbar\'s global "↻ USDT" button',
    ],
  },
  {
    version: '1.4.45',
    date: '2026-08-11',
    changes: [
      'Fix: token discovery (finding tokens beyond the hardcoded default list) has been silently broken in production for every EVM chain, not just BSC — docker-compose.yml\'s tron-hdwallet build block never passed VUE_APP_ETHERSCAN_KEY as a Docker build ARG, so the deployed bundle has been shipping with an empty key this whole time. Added the missing build args.',
      'BSC specifically also needs a different fix: Etherscan discontinued free-tier API access for BNB Chain entirely (also Base/Optimism) — chainId 56 403s regardless of key, Ethereum/Polygon are unaffected. Routed BSC token discovery through MegaNode (nodereal.io, BNB Chain\'s own recommended free replacement) via nr_getTokenHoldings instead — requires a free VUE_APP_MEGANODE_KEY (not yet configured; degrades gracefully to the default-list-only behavior already in place until one is added)',
    ],
  },
  {
    version: '1.4.44',
    date: '2026-08-11',
    changes: [
      'Added INJ (Injective) and NEAR to the BSC wallet\'s default token list — the rest of the requested set (SUSHI, FIL, AXS, DOGE, BCH, CAKE) were already there. Contract addresses verified on-chain (decimals + symbol read directly from each contract) before adding, both priced via the Binance-first lookup (INJUSDT/NEARUSDT confirmed live)',
    ],
  },
  {
    version: '1.4.43',
    date: '2026-08-11',
    changes: [
      'Fix: audited every ticker in the BSC/ETH/Polygon/Tron/Solana default token lists against the Binance symbol map — WBNB and WMATIC (wrapped-token tickers, distinct keys from the bare BNB/MATIC already mapped) and Tron\'s BTTC (ticker didn\'t match the existing BTT entry) had no price source at all and always showed $0',
      'Added Solana default list tickers (RAY, BONK, JTO, WIF) to the Binance map too — verified live that all of them have USDT pairs',
    ],
  },
  {
    version: '1.4.42',
    date: '2026-08-11',
    changes: [
      'Token USD/USDT pricing now tries Binance first, by ticker, before falling back to CoinGecko\'s per-contract lookup — Binance has a USDT pair for nearly every default BSC/ETH/Polygon/Tron token (DOT, DOGE, SHIB, ADA, XRP, and 25+ others added to the symbol map) and answers all of them in a single batched request with none of CoinGecko\'s per-address limit or aggressive rate limit',
      'CoinGecko contract lookup is now only a fallback for tokens Binance doesn\'t list (custom/obscure discovered tokens) — most wallets should never hit it at all',
    ],
  },
  {
    version: '1.4.41',
    date: '2026-08-10',
    changes: [
      'Fix: token USD values on the BSC wallet (SHIB, DOGE, and others further down the default token list) were still showing $0 even after the "1 contract address per request" fix — CoinGecko\'s real anonymous rate limit turned out to be roughly 4 requests before every subsequent one 429s, so most of a 45-token list was still failing silently',
      'Contract price lookups now go fully serial with a delay between requests (stops early on a 429 instead of burning through the rest of the list), and skip fetching a price entirely for default tokens at zero balance — 0 balance × any price is $0 regardless, so that call was wasted budget',
      'Relabeled "Value (USD)" / "Price (USD)" column headers to "(USDT)" across all wallets and the Dashboard — this app\'s prices are already USDT-denominated (Binance USDT pairs primary, stablecoins hardcoded to $1.00)',
      'Feature: "↻ USDT" button in the navbar — refreshes USDT-equivalent prices on whichever wallet page (or Dashboard) is currently open immediately, instead of waiting for its own 60s auto-refresh',
    ],
  },
  {
    version: '1.4.40',
    date: '2026-08-10',
    changes: [
      'CSP frame-ancestors now also allows backoffice.bitimen.com — the real production admin panel (separate host, 185.226.117.54) also embeds this app via the same HD Wallet Management iframe, not just the standby/staging admin domains',
    ],
  },
  {
    version: '1.4.39',
    date: '2026-08-10',
    changes: [
      'Now embeddable inside the Bitimen admin panel (exchange-admin) via an iframe on the "HD Wallet Management" sidebar item — see exchange-admin/CLAUDE.md; login/auth here stays fully separate (no SSO) to keep Ledger/payout access isolated from the admin session',
      'nginx.conf now sends Content-Security-Policy: frame-ancestors, restricted to the specific admin domains allowed to iframe this app (devadmin.zekabot.com, adminstage2.zekabot.com, backoffice2.bitimen.com, devadmin2.zekabot.com) — previously unset (embeddable by any origin)',
    ],
  },
  {
    version: '1.4.38',
    date: '2026-08-10',
    changes: [
      'Fix: ERC20/BEP20/Polygon token USD values showing $0 for everything except a token\'s balance — CoinGecko\'s public token_price API now rejects any request with more than 1 contract address (used to accept large batches); the app was still sending all ~45 default tokens in one request, so the whole batch errored out and every token silently priced at $0',
      'fetchPricesByContract now sends one contract address per request (4 in flight at a time) and only caches a real price, never a false $0 from an errored batch',
      'EVM stablecoins (USDT/USDC/BUSD/DAI/etc.) are now hardcoded to $1.00 like Tron TRC20 already was, skipping the API call entirely',
    ],
  },
  {
    version: '1.4.37',
    date: '2026-08-10',
    changes: [
      'Feature: animated loading indicators on pages that fetch data over the network — Address Book, Transfer History, and Dashboard\'s initial price load now show a spinner block instead of a static "Loading…" line',
      'Address Matrix (all six wallets) and the BTC wallet\'s own address matrix: Refresh button now shows a spinner, and the initial derive is a proper loading block instead of briefly flashing "No cached addresses yet"',
      'Extracted a shared PageLoader component (spinner-border + message) reused across all of the above, matching the existing spinner style already used in TxTable and the token-scanning rows',
    ],
  },
  {
    version: '1.4.36',
    date: '2026-08-10',
    changes: [
      'Feature: balance tables on the Ethereum, BSC, Polygon, Tron, and Solana wallet pages now sort by USD value descending — the native token (ETH/BNB/MATIC/TRX/SOL) stays pinned to the top row regardless of its value',
    ],
  },
  {
    version: '1.4.35',
    date: '2026-07-14',
    changes: [
      'Feature: Address Matrix + Tree views (from the BTC wallet) added to Ethereum, BSC, Polygon, Solana, and Tron wallets',
      'ETH/BSC/Polygon: matrix/tree addresses are derived from a cached account-level pubkey/chaincode (m/44\'/60\'/0\'/0) via public-key-only BIP32 derivation — populates automatically after one Ledger connect, no reconnect needed per address',
      'Solana/Tron: matrix/tree show every address already connected via Ledger (their Ledger apps don\'t expose a chaincode, so sibling addresses can\'t be derived from a public key alone — this is a hardware/protocol limitation, not a bug)',
      'Extracted a shared AddressMatrix/AddressTree component pair (generalized from the BTC-only version) reused across all six wallets',
    ],
  },
  {
    version: '1.4.34',
    date: '2026-07-14',
    changes: [
      'Fix: cached account xpubs written before the v1.4.31 hex-encoding fix (stale localStorage data) crashed address derivation with "Invalid hex string" errors — corrupt cache entries are now detected and ignored (falls back gracefully, self-heals on next reconnect) instead of throwing',
      'Hardening: saveAccountNode now validates hex format before writing to the cache at all, so malformed key data can never be persisted again',
    ],
  },
  {
    version: '1.4.33',
    date: '2026-07-13',
    changes: [
      'Fix: "Address Matrix Empty" error notice was showing automatically every time the BTC wallet page loaded, even before you had connected anything — now it only shows when you explicitly click Refresh with nothing cached',
    ],
  },
  {
    version: '1.4.32',
    date: '2026-07-13',
    changes: [
      'Fix: BTC Address Tree node spacing — switched to fixed per-node sizing (d3 nodeSize) instead of a stretched-to-fit layout, so labels no longer overlap vertically or horizontally regardless of how many accounts/addresses are shown',
      'Feature: BTC Address Tree address nodes now show a heat-mapped background color (bitcoin-orange intensity) scaled by balance, so you can spot which addresses hold funds at a glance',
    ],
  },
  {
    version: '1.4.31',
    date: '2026-07-13',
    changes: [
      'Fix: Address Matrix/Tree derived nothing ("Invalid hex string" / "pointHex must be hex string") — bs58check.decode() returns a plain Uint8Array in the browser, and Uint8Array.toString(\'hex\') silently ignores the encoding argument, producing garbage instead of hex; xpub parsing now wraps the result in Buffer.from() first',
    ],
  },
  {
    version: '1.4.30',
    date: '2026-07-13',
    changes: [
      'Debug: Address Matrix/Tree refresh now logs devices, groups, and cached-xpub status to the browser console, and shows a visible notice ("Address Matrix Empty") if no cached addresses are found, instead of silently doing nothing',
    ],
  },
  {
    version: '1.4.29',
    date: '2026-07-13',
    changes: [
      'Feature: BTC wallet Address Overview now has a Tree view alongside the Matrix — a D3 hierarchy diagram rooted at each Ledger device, branching into HD account groups, then individual addresses with live balances. Click any address leaf to switch to it, same as the matrix',
    ],
  },
  {
    version: '1.4.28',
    date: '2026-07-13',
    changes: [
      'Debug: if fetching the account xpub (needed for the Address Matrix / device fingerprint) fails, it now shows a visible error notice instead of silently logging to console — previously the account still saved but with no device fingerprint, so it was silently excluded from the matrix with no indication why',
    ],
  },
  {
    version: '1.4.27',
    date: '2026-07-13',
    changes: [
      'Fix: BTC Address Matrix / account cache now keyed per physical Ledger device, not just account group index — previously two different Ledgers with e.g. both having an "Account #0" would collide and overwrite each other\'s cached addresses/balances',
      'Feature: device identity is derived from each account xpub\'s parent fingerprint (BIP32), which is stable per-seed and differs across devices; adds a "Ledger Device" switcher when more than one device has been used, and warns if the wrong physical Ledger is connected for the selected device',
    ],
  },
  {
    version: '1.4.26',
    date: '2026-07-13',
    changes: [
      'Feature: BTC wallet shows an Address Matrix on page load — rows are HD account groups, columns are address indices, each cell shows the address and its live balance (auto-refreshed, click a cell to switch to that account)',
      'Under the hood: once an HD account group is connected, its account-level public key/chaincode is fetched from the Ledger and cached locally, so all address indices within that group can be derived and their balances checked without reconnecting the hardware wallet for every address',
    ],
  },
  {
    version: '1.4.25',
    date: '2026-07-13',
    changes: [
      'Feature: BTC wallet now models the real two-level HD structure — top dropdown picks the HD account/group (m/84\'/0\'/x\'), bottom dropdown picks the address index within that group (.../0/y). Previously all 3 addresses under one Ledger group showed up as if they were 3 separate top-level accounts (0, 1, 2)',
    ],
  },
  {
    version: '1.4.24',
    date: '2026-07-13',
    changes: [
      'Fix: BTC wallet "Switch Account" dropdown and the manual "Account Index" field were bound to the same value, so editing either one moved both — now decoupled: typing the index field no longer moves the dropdown, and the dropdown only updates the index (and reconnects) when you explicitly pick from it',
    ],
  },
  {
    version: '1.4.23',
    date: '2026-07-13',
    changes: [
      'Feature: BTC wallet now shows a "Switch Account" dropdown listing all previously loaded Ledger accounts (like Accounts Manager) — pick one to reconnect instantly instead of typing the account index by hand',
    ],
  },
  {
    version: '1.4.22',
    date: '2026-07-13',
    changes: [
      'Fix: BTC address from Ledger came back empty, breaking balance lookup ("could not fetch balance... base58 error") — getWalletPublicKey was called with the account-level path instead of the full leaf path (84\'/0\'/N\'/0/0), and the newer Ledger BTC app library only returns an address for a leaf path',
    ],
  },
  {
    version: '1.4.21',
    date: '2026-07-13',
    changes: [
      'Fix: index.html had no cache-control header, so browsers could keep serving a stale cached page pointing at old hashed JS bundles after a deploy — now sent with no-cache so every load revalidates',
    ],
  },
  {
    version: '1.4.20',
    date: '2026-07-13',
    changes: [
      'Fix: Solana "Full History" page (/solana/transactions) still used the non-indexing PublicNode RPC directly — switched it to the same /solana-rpc/ nginx proxy used on the wallet page',
    ],
  },
  {
    version: '1.4.19',
    date: '2026-07-13',
    changes: [
      'Fix: Solana tx history still failed in the browser — api.mainnet-beta.solana.com returns 403 Access Forbidden when it sees a browser Origin header, even though it works fine server-side. Added an nginx reverse proxy (/solana-rpc/) that strips the Origin header before forwarding, so the browser calls a same-origin path instead of hitting the RPC directly',
    ],
  },
  {
    version: '1.4.18',
    date: '2026-07-13',
    changes: [
      'Fix: Solana wallet transaction history was empty for many addresses because PublicNode RPC does not fully index getSignaturesForAddress — switched to the official Solana mainnet-beta RPC for tx history lookups',
    ],
  },
  {
    version: '1.4.17',
    date: '2026-07-13',
    changes: [
      'Debug: BTC balance error now shows the actual failure reason (HTTP status/body or network error) from each source (Blockstream, mempool.space), and logs full detail to browser console',
    ],
  },
  {
    version: '1.4.16',
    date: '2026-07-13',
    changes: [
      'Fix: BTC balance fetch now falls back to mempool.space if Blockstream.info fails or rate-limits, instead of showing an error',
    ],
  },
  {
    version: '1.4.15',
    date: '2026-07-12',
    changes: [
      'Fix: "Add Address" button on Tron/Ethereum/BSC/Polygon/Solana wallet pages was broken (posted to a dead legacy API) — now saves to the shared PocketBase address book, same as the Address Book page',
      'Feature: each wallet page (Tron, Ethereum, BSC, Polygon, Solana) now shows a Send/Receive transaction history section inline, with a link to the full history view',
    ],
  },
  {
    version: '1.4.14',
    date: '2026-07-12',
    changes: [
      'Fix: Tron wallet TRC20 balances now correct — USDT/BTTC/WIN always show real on-chain balance (not 0), stablecoin prices hardcoded to $1.00 to survive CoinGecko rate limits, address case preserved for contract lookups',
    ],
  },
  {
    version: '1.4.13',
    date: '2026-07-12',
    changes: [
      'Tron wallet: USDT, BTTC, and WIN always shown in the token list even with zero balance',
    ],
  },
  {
    version: '1.4.12',
    date: '2026-07-12',
    changes: [
      'Fix: BSC transfers now use EIP-1559 type-2 transactions — eliminates "Invalid v value" error caused by Ledger Ethereum app returning raw parity (0/1) for BSC chainId=56 instead of full EIP-155 v encoding',
    ],
  },
  {
    version: '1.4.11',
    date: '2026-07-12',
    changes: [
      'Fix: ETH/BSC/Polygon transfers — v value now derived by address recovery (try both EIP-155 parities, pick the one that recovers to the wallet address) — eliminates "Invalid v value" regardless of how the Ledger formats it',
    ],
  },
  {
    version: '1.4.10',
    date: '2026-07-12',
    changes: [
      'Fix: BSC transfer v value now handles both hex and decimal string formats from Ledger — auto-detects correct interpretation for chainId=56',
    ],
  },
  {
    version: '1.4.9',
    date: '2026-07-12',
    changes: [
      'Fix: BSC/ETH/Polygon wallets now always show all default tokens even with zero balance — previously only tokens with USD value > $0.01 were displayed',
    ],
  },
  {
    version: '1.4.8',
    date: '2026-07-12',
    changes: [
      'Fix: friendly error message when Ledger has wrong app open (CLA_NOT_SUPPORTED 0x6e00) — ETH, BSC, and Polygon all require the Ethereum Ledger app',
    ],
  },
  {
    version: '1.4.7',
    date: '2026-07-12',
    changes: [
      'BSC wallet: expanded default token list to 45 tokens — XRP, LTC, DOT, ADA, SOL, DOGE, AVAX, MATIC, ATOM, LINK, UNI, AAVE, SHIB, BCH, ETC, FTM, AXS, SUSHI, SNX, MKR, MANA, SAND, BAT, VET, XLM, EOS, ZEC, FIL, XTZ, CELR, ONE, GMT, FLOKI, TON, IOTA, ZIL and more',
    ],
  },
  {
    version: '1.4.6',
    date: '2026-07-12',
    changes: [
      'Fix: ETH/BSC/Polygon transfer now works — Ledger signature r/s returned as comma-separated decimal strings in the browser bundle; now parsed correctly before hex-encoding',
    ],
  },
  {
    version: '1.4.5',
    date: '2026-07-12',
    changes: [
      'Debug: server-side transfer trace logging via /client-log nginx endpoint (readable with docker logs)',
    ],
  },
  {
    version: '1.4.4',
    date: '2026-07-11',
    changes: [
      'Fix: Ledger signature r/s bytes now correctly hex-encoded on ETH/BSC/Polygon — Buffer was being coerced to comma-separated decimals, causing INVALID_ARGUMENT on broadcast',
    ],
  },
  {
    version: '1.4.3',
    date: '2026-07-11',
    changes: [
      'Fix: Send modal now opens correctly on ETH, BSC, and Polygon wallets — vue-modal default export was being referenced incorrectly (m.Modal → m.default)',
    ],
  },
  {
    version: '1.4.2',
    date: '2026-07-11',
    changes: [
      'Fix: replace defunct Cloudflare Ethereum RPC with PublicNode — eliminates -32603 Internal error on ETH balance queries',
      'AccountsManager and EthereumWallet now use ethereum-rpc.publicnode.com as default ETH RPC',
    ],
  },
  {
    version: '1.4.1',
    date: '2026-06-23',
    changes: [
      'Binance API as primary price source — faster, no rate limits, no API key required',
      'CoinGecko kept as automatic fallback for tokens not listed on Binance',
      'Stablecoins (USDT, USDC, DAI, BUSD, USDD) hardcoded to $1.00 — no API call needed',
      'Accounts Manager now shows native balance and USDT value per account with ↻ Refresh',
      'Portfolio total banner on Accounts Manager page across all saved accounts',
      'Dashboard total value now formatted with M/K shorthand for large portfolios',
      'Price source label "via Binance" shown on Dashboard',
    ],
  },
  {
    version: '1.4.0',
    date: '2026-06-23',
    changes: [
      'PocketBase database backend — multi-user auth with email + password',
      'Transfer history page — searchable ledger of all sends with CSV export',
      'Address book — labeled addresses with AML risk tracking and chain tagging',
      'AML checks logged to database with scores, signals, and timestamps',
      'Payout queues saved to database — save/load named queues across sessions',
      'Confirmed transfers auto-saved with txid, addresses, amount, chain, status',
      'User profile in Settings — change password via PocketBase auth',
      'PocketBase admin UI on port 8091 for user account management',
    ],
  },
  {
    version: '1.3.1',
    date: '2026-06-23',
    changes: [
      'Fix: palette color picker now visible in light mode (was hidden by v-if)',
    ],
  },
  {
    version: '1.3.0',
    date: '2026-06-23',
    changes: [
      'USDT Payout Manager — send USDT from one source to multiple targets across TRC20 / ERC20 / BEP20 / POL',
      'AML compliance check via AMLBot API — hard block for sanctions, soft block for darknet / mixer / scam',
      'Radial payout graph — source center node, targets with AML risk color rings, edge status animation',
      'Scheduling modes: manual, timed (at datetime), delay-after-previous, rotation slots',
      'Transfer queue with countdown timers, CSV export, and time log',
      'Bulk paste: import address,amount pairs for batch payout setup',
      'Animated TRX flow graph — N levels backward / M levels forward BFS traversal with D3 v7',
      'Click-to-zoom on graph nodes, semantic zoom labels, floating detail cards',
    ],
  },
  {
    version: '1.2.0',
    date: '2026-06-22',
    changes: [
      'Auto-discover all tokens with USD value > $0.01 on ETH / BSC / Polygon / Tron / Solana',
      'Token discovery via Etherscan tx history — no hardcoded list needed',
      'Prices fetched by contract address from CoinGecko',
      'Non-blocking token load: native balance shows immediately, tokens stream in',
    ],
  },
  {
    version: '1.1.0',
    date: '2026-06-22',
    changes: [
      'Add logout button to navbar',
      'Migrate ETH / BSC / Polygon to Etherscan API V2',
      'Password change now works correctly after logout',
    ],
  },
  {
    version: '1.0.8',
    date: '2026-06-01',
    changes: [
      'Theme palette selector and dark/light mode toggle',
      'Dark design system, chain logos, animations',
      'Added Bitcoin and Solana chain support',
      'Portfolio dashboard with activity charts',
      'Navbar with per-chain dropdowns',
    ],
  },
];
